import Http from "@/commons/Http";

const path = 'api/quick-protocol-create';

export default {

    async getAll(){
        return Http.get(`${path}`);
    },

    async getAllActive(){
        return Http.get(`${path}/active`);
    },

    async save(dto, id = ''){
        return Http.post(`${path}/${id}`, dto);
    },

    async delete(id = ''){
        return Http.delete(`${path}/${id}`);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async pagination(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/pagination?sort=${sort || 'q.name'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
    },

}